<template>
  <section
    v-if="this.show"
    class="browser-banner bg-grey-800  w-full h-16 bg-white flex flex-row justify-between items-center flex-shrink-0">
    <span class="info-sm text-base font-bold pl-6">
            {{ $t('frontend_browser_banner_download_suggest')}}
      <span class="text-pink">
        <a v-bind:href="chrome_url" target='_blank'>
          {{ $t('frontend_browser_banner_download_here')}}
        </a>
      </span>
    </span>
    <div class="flex flex-row justify-end">
      <gd-button  class="mr-6 flex items-center" @click="closeBanner();">x</gd-button>
    </div>
  </section>
</template>
<script>
import GdButton from '@groovepages/gd-ui-kit/components/Button';
import Bowser from "bowser";

export default {
  components: {
    GdButton
  },
  data() {
    return {
      chrome_url: 'https://www.google.com/chrome/',
      show: false
    };
  },
  created(){
    this.isNeedToShow();
  },
  methods:{
    isNeedToShow(){
      this.show = !this.isChrome() && !this.isBannerClosed();
    },
    isChrome()
    {
      const browser = Bowser.getParser(window.navigator.userAgent);

      return browser.is('Chrome');
    },
    isBannerClosed()
    {
      return !!sessionStorage.getItem('browser-banner-closed');
    },
    closeBanner(){
      sessionStorage.setItem('browser-banner-closed', 'true');
      this.show = false;
    }
  }
};
</script>
<style lang="css" scoped>
.browser-banner {
  position: sticky !important;
  top: 0;
  z-index: 1000;
}
</style>
